export const observationSchema = {
    auditName: "",
    auditNumber: "",
    auditType: "",
    auditYear: "",
    auditedClauses: [],
    auditedDocuments: [],
    auditedEntity: "",
    auditees: [
            {
              firstname: "Mridul"
            }
    ],
    auditors: [
        {
            firstname: "Mridul"
          }
    ],
    date: "",
    observationDate: "",
    isDraft: false,
    location: "",
    observationNumber: '',
    imageName: '',
    imageLink: "",
    documentProof: "",
    observationDetails: "",
}

